import { Box, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import logoComapny from "../assets/img/Logo.png";
import cover from "../assets/img/cover.png";
import Cookies from "universal-cookie";
import host from "../assets/js/Host";
import axios from "../assets/js/AxiosInterceptors";

const cookies =new Cookies();
export default function WelcomePage() {
  const [t] = useTranslation("common");
  const checkTokenIsValid = async () => {
    let result = null;
    let jwt = cookies.get("token");
    if(!jwt||jwt==null)
     return window.location.href='/'

    let headers = {
      jwt: jwt,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    };
    try {
      result = await axios({
        url: host + "roles",
        headers: headers,
        method: "get",
      });
    } catch (error) {
      
    }
  };
  useEffect(() => {
    checkTokenIsValid()
  }, []);
  return (
    <Box
      style={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "97vh",
        gap: 20,
      }}
    >
      <img
        src={cover}
        style={{
          position: "absolute",
          height: "100vh",
          width: "100vw",
          top: "50%",
          left: "50%",
          transform: "translate(-30%, -60%) scale(1.7) scaleX(-1)",
          zIndex: -1,
          opacity: 0.6,
        }}
      />
      <img
        src={logoComapny}
        style={{
          width: "280px",
          height: "280px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: "60px",
          }}
        >
          مرحبا بك في
        </Typography>
        <Box
          sx={{
            "& span": {
              fontFamily: "rubik",
            },
          }}
        >
          <span
            // className="titleName"
            style={{
              color: "#1e6a99",
              fontSize: "75px",
              marginRight: "5px",
              fontWeight: "600",
            }}
          >
            Ticket
          </span>
          <span
            // className="titleName"
            style={{ color: "#fe3847", fontSize: "75px", fontWeight: "600" }}
          >
            System
          </span>
        </Box>
      </Box>
    </Box>
  );
}
